export default {
  liveStats: {
    openVsx: { publisher: 'juanlias', name: 'ultra-instinct-theme' },
    marketplace: { publisher: 'JuanLias', name: 'ultra-instinct-theme' },
  },
  meta: {
    title: 'ULTRA INSTINCT THEME',
    headline: 'Para <br> <span class="text-electric-purple">O Vazio.</span>',
    label: 'Case Study 04',
    description:
      'Uma trilogia de temas para VS Code projetada para desenvolvedores neurodivergentes, eliminando o ruído visual para atingir foco absoluto.',
    chips: [
      { text: 'Open Source', dotColor: 'bg-electric-purple' },
      { text: 'VS Code', dotColor: 'bg-blue-500' },
      { text: '2026' },
    ],
    heroImage:
      'https://images.unsplash.com/photo-1629654297299-c8506221ca97?q=80&w=1920&auto=format&fit=crop',
    heroLogo:
      'https://raw.githubusercontent.com/juanlias/ultra-instinct-theme/master/images/icon.png',
  },
  sidebar: {
    title: 'Índice',
    meta: [
      { label: 'Autor', value: 'Juan Lias' },
      { label: 'Tipo', value: 'Extensão VS Code' },
      { label: 'Papel', value: 'Designer & Desenvolvedor' },
      { label: 'Stack', value: 'JSON, TypeScript, VS Code API' },
      { label: 'Versão', value: 'v0.1.3' },
      { label: 'Licença', value: 'MIT Open Source' },
      { label: 'Ano', value: '2026' },
    ],
    cta: 'Ver no GitHub',
    ctaLink: 'https://github.com/juanlias/ultra-instinct-theme',
    repoLink: 'https://github.com/juanlias/ultra-instinct-theme',
  },
  sections: {
    overview: {
      id: 'overview',
      menuLabel: 'Visão Geral',
      title: 'O Projeto',
      highlight:
        'Ultra Instinct é uma trilogia de temas para VS Code projetada com perspectiva neurodivergente — uma interface construída para desaparecer, deixando a lógica no centro do palco.',
      cards: [
        {
          title: 'O Vazio',
          text: 'Design ultra-minimal que remove a fricção cognitiva: sem bordas desnecessárias, sem contrastes agressivos, sem colchetes coloridos.',
        },
        {
          title: 'Três Variantes',
          text: 'Sign (depuração intensa), Mastered (fluxo diário tranquilo) e Mastered Light (ambientes iluminados) — cada um sintonizado a um estado mental.',
        },
        {
          title: 'WCAG 2.1 AA',
          text: 'Todos os índices de contraste superam 4.5:1. Desenvolvimento de alta performance não deveria custar sobrecarga sensorial.',
        },
      ],
    },
    enfoque: {
      id: 'enfoque',
      menuLabel: 'Filosofia',
      label: 'Filosofia de Design',
      title: 'O Conceito do Vazio',
      description:
        'Como desenvolvedor com <strong>Autismo e Alto Potencial</strong>, achei os temas padrão cognitivamente avassaladores — cada borda desnecessária e contraste brusco quebrava meu foco. Ultra Instinct nasceu para resolver meu próprio problema: uma interface amigável sensorialmente que se apaga, deixando apenas o código.',
      tags: [
        'Design Neurodivergente',
        'Amigável ao Sensorial',
        'WCAG 2.1 AA',
        'Foco Profundo',
        'Estado de Fluxo',
      ],
    },
    problema: {
      id: 'problema',
      menuLabel: 'O Desafio',
      title: 'O Problema',
      description:
        'Os temas padrão são feitos para o desenvolvedor médio. Para programadores neurodivergentes, cores intensas, bordas excessivas e colchetes coloridos geram interrupções sensoriais constantes que quebram o estado de fluxo e causam fadiga cognitiva.',
      stats: [
        { value: 'v0.1.3', label: 'Versão', liveKey: 'version' },
        { value: '37+', label: 'Marketplace', liveKey: 'marketplaceInstalls' },
        { value: '2K+', label: 'Open VSX', liveKey: 'openVsxDownloads' },
      ],
    },
    branding: {
      id: 'branding',
      menuLabel: 'Paleta',
      title: 'Variantes do Tema',
      description:
        'Três sistemas de cores distintos, cada um orientado a um estado mental e ambiente de trabalho diferente.',
      palette: [
        { name: 'Sign — Carvão Profundo', hex: '#0d1017' },
        { name: 'Sign — Azul Elétrico', hex: '#82aaff' },
        { name: 'Sign — Índigo', hex: '#7986cb' },
        { name: 'Mastered — Vazio Escuro', hex: '#141118' },
        { name: 'Mastered — Púrpura Real', hex: '#a78bfa' },
        { name: 'Mastered — Prata', hex: '#94a3b8' },
        { name: 'Light — Prata Divina', hex: '#e8eaf6' },
        { name: 'Light — Púrpura Aura', hex: '#7c3aed' },
      ],
      typography:
        'Ultra Instinct Sign (Depuração intensa) · Mastered (Trabalho diário) · Mastered Light (Apresentações e ambientes iluminados)',
    },
    tecnologia: {
      id: 'tecnologia',
      menuLabel: 'Stack Tecnológico',
      title: 'Por Dentro',
      categories: [
        { name: 'Formato', items: ['JSON Theme Spec', 'VSIX Package'] },
        { name: 'Padrões', items: ['WCAG 2.1 AA', 'Licença MIT', 'Versionamento Semântico'] },
      ],
    },
    footer: {
      prev: null,
      next: { label: 'Próximo Case', title: 'Hyperdrive', link: '/works/hyperdrive' },
    },
  },
}
